import React, { useState } from "react";
import clsx from "clsx";

import { Button, Hidden, Theme, useMediaQuery } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { BorderColor as BorderColorOutlinedIcon } from "@mui/icons-material";
import { useHistory } from "react-router";

import useApp from "hooks/useApp";
import useCatalogDetail from "hooks/useCatalogDetail";
import { IDesign } from "types/design";

import { DiseaseTypeSelectDialog } from "./DiseaseTypeSelectDialog";

export const useStyles = makeStyles((theme: Theme) => ({
  buttonWithHiddenIcon: {
    '& span[class*="label"]': { whiteSpace: "nowrap" },
    [theme.breakpoints.only("xs")]: {
      "& .MuiButton-startIcon.MuiButton-iconSizeSmall": {
        marginRight: 0,
        marginLeft: 0,
      },
    },
    [theme.breakpoints.up("sm")]: {
      "& .MuiButton-startIcon.MuiButton-iconSizeSmall": {
        marginLeft: theme.spacing(-1),
      },
    },
  },
  flexOrder: {
    [theme.breakpoints.down('md')]: { order: 0, height: 32, minWidth: 40 },
    [theme.breakpoints.down('sm')]: { paddingLeft: 0, paddingRight: 0 },
  },
}));

interface CustomizeButtonProps {
  disabled?: boolean;
  isEvaluation: boolean;
}

export const CustomizeButton: React.FC<CustomizeButtonProps> = ({
  disabled = false,
  isEvaluation,
}) => {
  const mdUp = useMediaQuery((theme: Theme) => theme.breakpoints.up("md"));
  const history = useHistory();

  const [open, setOpen] = useState<boolean>(false);

  const { getDiseaseTypes } = useApp();
  let {
    catalog,
    isCustomPanel,
    isDraftCustomPanel,
    isSuggestedPanel,
    setCustomize,
    setDiseaseType,
  } = useCatalogDetail();
  catalog = catalog! as IDesign;

  const onCustomize = () => {
    if (isDraftCustomPanel && catalog?.id) {
      history.push(`/dashboard/draft-custom-panels/${catalog!.id}/edit`);
    } else if (isEvaluation) {
      // Evaluation Panel Customization
      if (isSuggestedPanel) {
        history.push("/evaluate-panel-options/suggested-panel-customize");
      } else if (isCustomPanel) {
        history.push(
          `/evaluate-panel-options/custom-panel-customize/${catalog?.id}`
        );
      } else {
        history.push(
          `/evaluate-panel-options/catalog-panel-customize/${catalog?.id}`
        );
      }
    } else {
      // Catalog Panel Customization
      if (
        Array.isArray(catalog?.diseaseType) &&
        catalog!.diseaseType.length > 1
      ) {
        setOpen(true);
      } else {
        setCustomize(true);
        setDiseaseType(getDiseaseTypes(catalog!.diseaseType)[0]);
      }
    }
  };

  const classes = useStyles();

  return (
    <>
      <Button
        startIcon={
          <Hidden smUp>
            <BorderColorOutlinedIcon />
          </Hidden>
        }
        className={clsx(classes.buttonWithHiddenIcon, classes.flexOrder)}
        variant="outlined"
        fullWidth={mdUp}
        size={mdUp ? "medium" : "small"}
        onClick={onCustomize}
        disabled={disabled}
      >
        <Hidden only="xs">Customize</Hidden>
      </Button>
      <DiseaseTypeSelectDialog open={open} onClose={() => setOpen(false)} />
    </>
  );
};
